
import type { PropType } from 'vue'
import type { QueryRankingElementActionConfig } from '../../composables/use-query-ranking-element-actions-config'
import type { ExplainScoreCriteriaMessages, ExplainTableData } from '../../models'
import {
  QueryRankingCategoryTypeEnum,
  RootScoreCriteriaTypeEnum,
} from '@empathybroker/tsclient-play/dist/enums/search/debug/result/score-criteria-detail-type.enum'

import { PinProductAction } from '@empathyco/playboard-core-domain'
import { defineComponent } from 'vue'

import { useQueryRankingElementActionsConfig } from '../../composables/use-query-ranking-element-actions-config'

import { ColorEnum } from '../../enums/color.enum'
import { ExplainUtils } from '../../utils/explain.utils'
import { EpbBadge } from '../shared/epb-badge'
import ExplainResultsRow from './explain-results-row.component.vue'

export default defineComponent({
  name: 'ExplainResultsScoreRow',
  components: {
    ExplainResultsRow,
    EpbBadge,
  },
  props: {
    level: {
      type: Number,
      default: 0,
    },
    messages: {
      type: Object,
      required: true,
    },
    rowData: {
      type: Object as PropType<ExplainTableData>,
      required: true,
    },
    backgroundColor: {
      type: String as PropType<ColorEnum>,
      required: false,
      default: ColorEnum.WHITE,
    },
  },
  setup(props) {
    const { getActionConfig } = useQueryRankingElementActionsConfig()

    function getQueryRankingActionConfig(index: number): QueryRankingElementActionConfig {
      const action =
        this.rowData.types[index] === PinProductAction
          ? PinProductAction
          : ExplainUtils.getQueryRankingElementConfigAction(props.rowData.types[index])

      return getActionConfig(action)
    }

    function isQueryRankingConfig(index: number): boolean {
      return (
        !!props.rowData?.types?.[index] &&
        (
          [
            QueryRankingCategoryTypeEnum.PRODUCTS,
            QueryRankingCategoryTypeEnum.ATTRIBUTES,
          ] as Array<string>
        ).includes(props.rowData.parent)
      )
    }

    return { getQueryRankingActionConfig, isQueryRankingConfig }
  },

  data() {
    return {
      baseClass: 'epb-explain-results-score-row',
      childrenExpanded: true,
    }
  },
  computed: {
    childRows(): ExplainTableData[] {
      return this.rowData?.details ?? []
    },
    isHeader(): boolean {
      return Object.values(RootScoreCriteriaTypeEnum).includes(this.rowData.fieldName)
    },
    rowLevelClass(): string {
      return `${this.baseClass}__text--level-${this.level}`
    },
    criteriaDetailMessages(): ExplainScoreCriteriaMessages {
      return ExplainUtils.getResultScoreCriteriaDetailMessages(
        this.rowData.fieldName,
        this.messages?.score,
      )
    },
    criteriaDetailText(): string {
      return this.rowData.fieldName ? this.criteriaDetailMessages.label : this.messages.total
    },
    criteriaDetailIcon(): string {
      return ExplainUtils.getResultScoreCriteriaDetailIcon(this.rowData.fieldName)
    },
    criteriaDetailIconBackgroundColor(): ColorEnum {
      return ExplainUtils.getResultScoreCriteriaDetailColor(this.rowData.fieldName)
    },
    criteriaDetailBackgroundColor(): ColorEnum {
      return (
        ExplainUtils.getResultScoreCriteriaDetailBackgroundColor(this.rowData.fieldName) ??
        this.backgroundColor
      )
    },
  },
  methods: {
    getValueType(index: number): string {
      return this.rowData?.types?.[index] ?? ''
    },
    isQueryRankingBuryAction(index: number): boolean {
      return this.rowData.types && this.rowData.types[index] === 'bury'
    },
  },
})
